module.exports = __webpack_public_path__ + "static/media/TN-Women-Dress-2.0.351fbfa4.svg";